import React from 'react';
import { useEffect, useRef } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSave } from '../context/SaveContext.jsx';
import { useAuth } from '../context/AuthContext.jsx';
import { MySelectBoxLabel } from '../component/ui/UI.jsx';
import { useIsMobile } from "@MyLib/System/Mobile.js";
import { ROUTE } from './Route.jsx';

const LinkButton = ({to, text, disabled=false}) => {
	const { pathname } = useLocation();
	const isActive = pathname.startsWith === to || pathname.startsWith(to);
	const {isMobile} = useIsMobile();

	return (
		<Link className={`btn ${isActive ? "btn-primary" : "btn-secondary"} ${isMobile?"btn-lg":"btn-sm"} ${disabled ? 'disabled' : ''}`}
			to={to}
		>
			{text}
		</Link>
	);
};

export const Header = ({ setHeaderHeight }) =>
{
	const { t, i18n } = useTranslation();
	const { buildDeck } = useSave();
	const { user } = useAuth();
	const {isMobile} = useIsMobile();
	const navRef = useRef(null);

	useEffect(() => {
		const resize = () => {
			if (navRef.current) {
				setHeaderHeight(navRef.current.offsetHeight);
			}
		};

		resize();
		window.addEventListener("resize", resize);
		return () => window.removeEventListener("resize", resize);
	}, []);

	return (
		<nav
			ref={navRef}
			className="navbar navbar-expand-md fixed-top my-bg-head p-0"
			style={{whiteSpace: "nowrap"}}
		>
			<div className="container-fluid">
				<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggler" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<Link className="navbar-brand p-1" to="/">{t("Title")}</Link>
				<div className="collapse navbar-collapse" id="navbarToggler">
					<ul className="navbar-nav me-auto gap-1">
						<li className="nav-item">
							<LinkButton to={ROUTE.MYDECK} text={t("Head_MyDeck")} />
						</li>
						<li className="nav-item">
							<LinkButton to={ROUTE.DECKBUILDER} text={t("Head_DeckBuilder")} disabled={!buildDeck} />
						</li>
						<li className="nav-item">
							<LinkButton to={ROUTE.CARDSEARCH} text={t("Head_CardSearch")} />
						</li>
						<li className="nav-item">
							<LinkButton to={ROUTE.SEARCHSETTING} text={t("Head_SearchSetting")} />
						</li>
						<li className="nav-item">
							<LinkButton to={ROUTE.OPTION} text={t("Head_Option")} />
						</li>
						<li className="nav-item">
							<Link className={`btn btn-success ${isMobile?"btn-lg":"btn-sm"}`} to={ROUTE.ACCOUNT}>
								{user ? t("Common_LoginNow") : t("Common_Login")}
							</Link>
						</li>
						<li className="nav-item">
							<MySelectBoxLabel
								itemList={[
									{value: "en", text: "en"},
									{value: "ja", text: "ja"}
								]}
								value={i18n.language}
								onChange={(e) => i18n.changeLanguage(e.target.value)}
							/>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	);
};
